import registerLink from '../../lib/register-link';

const registerLinkConfig = registerLink(
  'hac',
  {
    element: 'cta',
    location: 'read_the_basics',
  },
  'Check your credit score'
);

export default {
  title: 'First-time home buyer guide',
  cta: {
    ...registerLinkConfig,
  },
  items: [
    {
      text: 'Tips to get finances ready',
      href: '/article/mortgages/tips-for-first-time-home-buyers',
      children: [
        {
          text: 'How much house can you afford?',
          href: '/mortgages/how-much-house-can-i-afford',
          app: 'hac',
        },
        {
          text: 'How much down payment?',
          href: '/article/mortgages/how-much-down-payment-for-house',
        },
        {
          text: 'Calculate your mortgage payment',
          href: '/mortgages/mortgage-calculator',
          target: '_blank',
          app: 'mc',
        },
        {
          text: 'Get your credit score in shape',
          href: '/article/mortgages/credit-score-affects-mortgage-rate',
        },
        {
          text: 'Collecting preapproval documents',
          href: '/article/mortgages/documents-needed-for-a-mortgage-preapproval',
        },
      ],
    },
    {
      text: 'Find the best mortgage type for you',
      href: '/article/mortgages/programs-help-first-time-homebuyers',
    },
    {
      text: 'How to find the best mortgage lender',
      href: '/blog/mortgages/5-tips-finding-mortgage-lender',
      target: '_blank',
    },
    {
      text: 'Calculate your closing costs',
      href: '/article/mortgages/closing-costs-calculator',
    },
  ],
};
